import { useConsoleVersion } from './queries/useConsoleVersion';
import { getLoadedBuildId, isNewDeployment } from './deploymentIdentity';

/**
 * Returns true when the build currently deployed is different from the build
 * this tab is running.
 *
 * Polls /api/console-version (every 60s, see useConsoleVersion) and compares its
 * `buildId` — the deployed entry-chunk path — against the entry chunk this tab
 * booted from. See `deploymentIdentity` for why the project version alone is not
 * a sufficient signal.
 */
const DEPLOYED_VERSION = import.meta.env.REACT_APP_VERSION as
  | string
  | undefined;

export const useIsNewDeploymentAvailable = () => {
  const { data: latest } = useConsoleVersion();

  return isNewDeployment(latest, getLoadedBuildId(), DEPLOYED_VERSION);
};
